export default "__VITE_ASSET__64d85067__"